<template>
  <div>
      <h2>商品审核发布</h2>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>